module.exports = __webpack_public_path__ + "img/g-play.656096e1.png";